import { a as isNil } from "../../../../vendor-2b2dbafd.mjs";
import { d as defaultParseDateFunction } from "./input-text-parser-865b2bcd.mjs";
const isRange = (date) => {
  return typeof date === "object" && ("start" in date || "end" in date);
};
const parseSingleDate = (date) => typeof date === "string" ? defaultParseDateFunction(date) : new Date(date);
const parseModelValue = (date) => {
  if (Array.isArray(date)) {
    return date.map(parseSingleDate);
  }
  if (isRange(date)) {
    return {
      start: isNil(date.start) ? date.start : parseSingleDate(date.start),
      end: isNil(date.end) ? date.end : parseSingleDate(date.end)
    };
  }
  return parseSingleDate(date);
};
export {
  isRange as i,
  parseModelValue as p
};
//# sourceMappingURL=model-value-parser-ec23c3d6.mjs.map
